import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import { UserApiService } from 'src/app/user-api.service';
import { Router } from '@angular/router';
import { NotifiactionService } from 'src/app/services/notifiaction.service';

@Component({
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
  styleUrls: ['./lost-password.component.scss']
})
export class LostPasswordComponent implements OnInit {


  public username : string = "";
  public error : boolean = false;


  usernameFormControl = new FormControl();

  constructor(private userService : UserApiService, private router: Router, private notificationService :NotifiactionService) {
    
  }

  sendData() {
    // console.log("lost-password");

    if (this.username != ""){
      // console.log("lost-password");
      this.userService.LostPassword( this.username, "https://www.clem.mobi/connexion/reset-password").subscribe(response => {
        // console.log(response);
        this.notificationService.showNewSnackBar("Un email vous a été envoyé")
        this.router.navigate(['']);
        return;
      },
      error => {
        this.error = true;
        //this.notificationService.showNewSnackBar("Une erreur est survenue");
        // console.error(error);
      })
    }
  }

  ngOnInit() {
  }

}
